<div>
    <form [formGroup]="customerDetailsForm">
        <div class="column__list">
            <!-- <div class="card__list">
                <div class="tooltip-container">
                    <app-audi-text-input inputId="enter-customer-details-idNumber" label="ID number (if South African citizen)" isRequired="true"
                        formControlName="idNumber" (onblur)="onValidateInput('idNumber',null)" (valueChange)="onValidateInput('idNumber',$event)"
                        validationMessage="{{idNumberValidationMessage}}">
                    </app-audi-text-input>
                    <app-tooltip class="tooltip-top-right" tooltipText="{{contentTooltips | ContentTooltip:'ID Number'}}"></app-tooltip>
                </div>
            </div>
            <div class="card__list">
                <app-audi-text-input inputId="enter-customer-details-passportNumber" label="Or Passport number (if foreign national)" isRequired="true"
                    formControlName="passportNumber" (onblur)="onValidateInput('passportNumber',null)" (valueChange)="onValidateInput('passportNumber',$event)"
                    validationMessage="{{passportNumberValidationMessage}}">
                </app-audi-text-input>
            </div> -->
            <div class="card__list">
                <div class="tooltip-container">
                    <app-audi-text-input inputId="enter-customer-details-identifier" label="ID or Passport number" isRequired="true" formControlName="identifier" 
                        (onblur)="onValidateInput('identifier', null)" (valueChange)="onValidateInput('identifier', $event)" validationMessage="{{identifierValidationMessage}}">
                    </app-audi-text-input>
                    <app-tooltip
                        class="tooltip-top-right"
                        tooltipText="{{contentTooltips | ContentTooltip:'ID Number'}}">
                    </app-tooltip>
                </div>
            </div>
            <div class="card__list">
                <div class="tooltip-container">
                    <app-audi-text-input inputId="enter-customer-details-vin" label="VIN Number*" maxLength="17" isRequired="true" formControlName="vin"
                        (onblur)="onValidateInput('vin',null)" (valueChange)="onValidateInput('vin',$event)" validationMessage="{{vinValidationMessage}}">
                    </app-audi-text-input>
                    <app-tooltip class="tooltip-top-right" tooltipText="{{contentTooltips | ContentTooltip:'VIN'}}"></app-tooltip>
                </div>
            </div>
        </div>
        <app-audi-text variant="copy2" text="* Indicates required fields"></app-audi-text><br /><br />
        <app-audi-button text="Continue" [disabled]="!customerDetailsForm.valid" (click)="onAuthenticateExistingCustomer()">
        </app-audi-button><br /><br />
        <app-audi-button text="Back" (click)="onBack()" variant="secondary"></app-audi-button>
    </form>
</div>